import { Route, Routes, useNavigate } from "react-router-dom";
import { Breadcrumb, Col, PageHeader, Row } from "antd";
import React from "react";
import { PromotionForm } from "./PromotionForm";

export const NewPromotion = () => {
  const navigate = useNavigate();

  return (
    <Row className="page promotions">
      <Routes>
        <Route
          path=""
          element={
            <>
              <Breadcrumb>
                <Breadcrumb.Item key="dashboard">Dashboard</Breadcrumb.Item>
                <Breadcrumb.Item key="promotions">Discounts</Breadcrumb.Item>
                <Breadcrumb.Item key="new">New</Breadcrumb.Item>
              </Breadcrumb>
              <Col sm={24}>
                <PageHeader
                  title="New Discount"
                  className="site-page-header"
                  onBack={() => navigate("/discounts")}
                  extra={[]}
                />
              </Col>
              <Col sm={24}>
                <PromotionForm />
              </Col>
            </>
          }
        />
      </Routes>
    </Row>
  );
};
